(function () {
    'use strict';

    var mod = angular.module('uwAgenda.users');
    mod.directive('userSharedAgendaFilter', ['SharedAgendaService', 'UserSearchPaginationService', 'UserFilterService', UserSharedAgendaFilterFn]);

    function UserSharedAgendaFilterFn(SharedAgendaService, UserSearchPaginationService, UserFilterService) {

        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/users/templates/user-shared-agenda-filter.html',
            scope: {                
            }
        };
        return directive;

        function link(scope) {
            // number of set filter
            scope.numFilters = 0;

            scope.agendas = SharedAgendaService.data.agendas;

            // filter list
            scope.filter = function ($event, agenda) {

                $event.stopPropagation();

                //reset vars 
                scope.numFilters = 0;
                
                if (agenda !== null) {
                    agenda.vmSelected = !agenda.vmSelected;
                }
                
                refresh();                
            };


            // update filter states in local storage
            function getSelectedAgendaOwnerIds() {     
                let selectedAgendas = scope.agendas
                            .filter(a => a.vmSelected === true)
                            .map(a => a.owner.id);
                if (selectedAgendas.length === 0)
                {
                    selectedAgendas = [0];
                }
                return selectedAgendas
            }

            function refresh() {
                UserSearchPaginationService.data.pagination.sharedAgendaOwnerIds = getSelectedAgendaOwnerIds();
                UserSearchPaginationService.search();
                
                setSelectedItemCount();                
            } 

            function setSelectedItemCount() {
                scope.numFilters = 0;
                for (var i = 0; i < scope.agendas.length; i++) {
                    if (scope.agendas[i].vmSelected) {
                        scope.numFilters++;
                    }
                }
            }            
        } // link
    }
})();